import { useState } from 'react';
import { AppBar, Box, Tab, Tabs, Typography } from '@material-ui/core';
import BTTab from './BTTab/BTTab';
import ClientTab from './ClientCare/ClientTabPage';
import MatchesTab from './MatchesTab/MatchesTab';

export default function CareConnectPage() {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: unknown, newValue: number) => setTab(newValue);

  return (
    <Box p={5} style={{ backgroundColor: '#F0F0F0', minHeight: '100vh' }}>
      <Typography variant="h5" style={{ marginBottom: 16, fontWeight: 500 }}>
        CareConnect Hub
      </Typography>
      <AppBar
        position="static"
        color="transparent"
        style={{
          boxShadow: 'none',
          marginBottom: 16
        }}
      >
        <Tabs
          value={tab}
          onChange={handleTabChange}
          aria-label="careconnect tabs"
          TabIndicatorProps={{
            style: {
              backgroundColor: '#6f42f5'
            }
          }}
        >
          <Tab
            label="BT"
            className="tab"
            style={{
              color: tab === 0 ? '#6f42f5' : 'inherit'
            }}
          />
          <Tab
            label="Client"
            className="tab"
            style={{
              color: tab === 1 ? '#6f42f5' : 'inherit'
            }}
          />
          <Tab
            label="Matches"
            className="tab"
            style={{
              color: tab === 2 ? '#6f42f5' : 'inherit'
            }}
          />
        </Tabs>
      </AppBar>
      {tab === 0 && <BTTab />}
      {tab === 1 && <ClientTab />}
      {tab === 2 && <MatchesTab />}
    </Box>
  );
}
